module.exports = __webpack_public_path__ + "img/17.ef5ee931.jpg";